<div class="report-paper" [class.compact]="compact">
    <!-- Report title block -->
    <div class="report-title-block" *ngIf="orgName || reportTitle">
        <div class="report-org-name" *ngIf="orgName">{{ orgName }}</div>
        <div class="report-report-title" *ngIf="reportTitle">{{ reportTitle }}</div>
        <div class="report-date-subtitle" *ngIf="dateSubtitle">{{ dateSubtitle }}</div>
    </div>

    <!-- Scrollable wrapper for wide tables -->
    <div class="report-table-scroll">
        <!-- Every row is its own flex container, so the columns inside them only line up when
             the containers do. This element is the single box that resolves the table width;
             the header and all rows fill it, which is what makes one shared column grid. -->
        <div class="report-table-grid">
            <!-- Header row. matSort is inert unless a column opts in via `sortable`, and each
                 header cell renders the existing plain label when not sortable — so reports that
                 don't enable sorting are completely unchanged. -->
            <div class="report-table-header"
                 matSort
                 [matSortDisableClear]="true"
                 [matSortActive]="sortColumn || ''"
                 [matSortDirection]="sortDirection"
                 (matSortChange)="onSortChange($event)">
                <div class="report-cell label-cell"
                     [style.--report-label-span]="columnWeight(labelColumn)">
                    <span *ngIf="isSortable(labelColumn); else plainLabelHeader"
                          class="sortable-header"
                          [mat-sort-header]="labelColumn?.valueKey || ''">
                        {{ labelColumn?.label }}
                    </span>
                    <ng-template #plainLabelHeader>{{ labelColumn?.label }}</ng-template>
                </div>
                <div class="report-cell value-cell"
                     [class.numeric-cell]="isNumericFormat(col)"
                     [style.--report-col-weight]="columnWeight(col)"
                     [style.text-align]="col.align || (isNumericFormat(col) ? 'right' : 'left')"
                     *ngFor="let col of valueColumns; trackBy: trackByIndex">
                    <span *ngIf="isSortable(col); else plainValueHeader"
                          class="sortable-header"
                          [mat-sort-header]="col.valueKey"
                          [arrowPosition]="sortArrowPosition(col)">
                        {{ col.label }}
                    </span>
                    <ng-template #plainValueHeader>{{ col.label }}</ng-template>
                </div>
            </div>

            <!-- Data rows -->
            <div class="report-table-row"
                 *ngFor="let row of displayRows; trackBy: trackByIndex"
                 [class.category-header]="row.categoryHeader && !row.subTotal && !row.grandTotal"
                 [class.sub-total]="row.subTotal || row.nestedTotal"
                 [class.grand-total]="row.grandTotal"
                 [class.collapsible]="row.collapsible"
                 [class.collapsed]="row.collapsible && row.show === false"
                 [class.overflow-row]="row.overflow"
                 (click)="row.collapsible ? toggleRow(row) : null">

                <!-- Label cell with indentation + collapse icon. On sub-total/grand-total rows the
                     label covers the text columns the row skips, so it publishes two numbers: the
                     free-width share it claims (its own weight plus theirs), and how many cells it
                     covers — the stylesheet reserves their padding and width floor by count, since
                     those don't scale with weight. -->
                <div class="report-cell label-cell"
                     [style.--report-label-span]="labelFlexGrow(row)"
                     [style.--report-label-skipped]="labelSkippedColumns(row)"
                     [ngStyle]="{'padding-left': labelPadding(row), 'margin-right': labelMarginRight(row)}">
                    <mat-icon *ngIf="row.collapsible" class="collapse-icon">
                        {{ row.show === false ? 'chevron_right' : 'expand_more' }}
                    </mat-icon>
                    <span *ngIf="isRowClickable(row)"
                          class="label-text category-link"
                          (click)="onCategoryClick($event, row)">
                        {{ row[labelColumn?.valueKey] || row['label'] }}
                    </span>
                    <span *ngIf="!isRowClickable(row)"
                          class="label-text">
                        {{ row[labelColumn?.valueKey] || row['label'] }}
                    </span>
                </div>

                <!-- Value cells. For sub-total / grand-total rows we skip the "text" columns
                     (non-money/non-percent) so the label cell can flex-grow across them — keeps
                     long "Total for …" labels from wrapping into a single narrow column. -->
                <div class="report-cell value-cell"
                     [style.--report-col-weight]="columnWeight(col)"
                     [style.text-align]="col.align || (isNumericFormat(col) ? 'right' : 'left')"
                     *ngFor="let col of valueColumnsForRow(row); trackBy: trackByIndex">
                    <span *ngIf="isMoney(col) && formatValue(row, col) != null">
                        {{ row[col.valueKey] | legfiCurrency:'USD':'symbol':'.2' }}
                    </span>
                    <span *ngIf="isPercent(col) && formatValue(row, col) != null">
                        {{ row[col.valueKey] }}%
                    </span>
                    <app-reference-column *ngIf="isReference(col) && row[col.valueKey]?.type"
                                          [reference]="row[col.valueKey]">
                    </app-reference-column>
                    <span *ngIf="!isMoney(col) && !isPercent(col) && !isReference(col) && formatValue(row, col) != null">
                        {{ row[col.valueKey] }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
